import { useCallback } from 'react';
import { useIsomorphicLayoutEffect } from '@direct-frontend/stdlib';

export const useDimmedTarget = (targetElement: HTMLElement | null, isActive: boolean, opacity: number) => {
    const applyOpacity = useCallback(() => {
        if (!targetElement || !isActive) {
            return undefined;
        }

        const previousOpacity = targetElement.style.opacity;
        // eslint-disable-next-line react-hooks/immutability -- targetElement — внешний DOM-узел, переданный через ref, и единственный способ его приглушить — мутировать inline-стиль напрямую
        targetElement.style.opacity = String(opacity);

        return () => {
            targetElement.style.opacity = previousOpacity;
        };
    }, [targetElement, isActive, opacity]);

    useIsomorphicLayoutEffect(applyOpacity, [applyOpacity]);
};
